<template>
    <div class="modal-container">
        <form @submit.prevent="handleSubmit" class="modal-form">
            <div class="modal-header">
                <div class="icon-container">
                    <PhEnvelope :size="24" class="text-gray-500" />
                </div>
                <div class="header-text">
                    <h2>Add Email Address</h2>
                    <p>Add a new email address for this employee</p>
                </div>
            </div>

            <div class="modal-body">
                <div class="form-row">
                    <label>Email Address</label>
                    <PrimeInputText
                        v-model="formData.email"
                        type="email"
                        placeholder="email@example.com"
                        class="w-full"
                    />
                </div>
            </div>

            <div class="modal-footer">
                <PrimeButton label="Cancel" @click="closeDialog" class="p-btn-root_secondary" :disabled="isLoading" />
                <PrimeButton label="Add Email" type="submit" :loading="isLoading" />
            </div>
        </form>
    </div>
</template>

<script setup lang="ts">
import { PhEnvelope } from '@phosphor-icons/vue';
import { businessService } from '~/services/business-service';
import { ModalNames } from '~/types/modals';
import { memberFacingMessage } from '~/utils/errors';

const dialogRef = getDialogRef(ModalNames.ADD_EMPLOYEE_EMAIL);
const { showSuccess, showError } = useGlobalToast();
const isLoading = ref(false);

const formData = reactive({
    email: '',
});

const companyId = computed(() => dialogRef.value?.data?.companyId);
const employeeId = computed(() => dialogRef.value?.data?.employeeId);

const closeDialog = () => {
    dialogRef.value.close();
};

const handleSubmit = async () => {
    if (!formData.email) {
        showError('Error', 'Email address is required');
        return;
    }

    isLoading.value = true;
    try {
        await businessService.addEmployeeEmail(companyId.value, employeeId.value, formData.email);
        showSuccess('Success', 'Email added successfully');
        dialogRef.value.close({ updated: true });
    } catch (error) {
        showError('Error', memberFacingMessage(error, 'Failed to add email'));
    } finally {
        isLoading.value = false;
    }
};
</script>

<style lang="scss" scoped>
@use '../../../assets/styles/business-form-modal';
</style>
